module.exports = __webpack_public_path__ + "static/media/24UHCHR17.a6ab9cd0.jpg";